export default "__VITE_ASSET__I1Wm2J6D__"